<script>
    import Icon from 'svelte-awesome';
    import {faPlusCircle} from '@fortawesome/free-solid-svg-icons';
    
    import CompetitorCard from '../components/CompetitorCard.svelte';

    export let model;


    const addNew = function(){
       let newItem = {
            url: null
        }
	    model = [...model, newItem];
    }
</script>

<div class="overflow-auto">
    {#each model as competitor, i}
    <div class="w-1/2 float-left">
       <CompetitorCard bind:model={competitor} />
    </div>
    {/each}
    <div class="w-1/2 h-full float-left p-4">
        <button type="button" on:click={addNew}>
            <Icon data={faPlusCircle} scale="3" class="text-main"/>
        </button>
    </div>
</div>